/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

export const ActionsList = styled.ul({
  listStyle: 'none',
  paddingLeft: 0,
  marginTop: `${gridSize() * 1.5}px`,
  li: {
    display: 'inline-block',
    '&:not(:first-child)': {
      marginLeft: `${gridSize() * 0.5}px`,
      '&::before': {
        content: "'\xb7'",
        marginRight: `${gridSize() * 0.5}px`,
      },
    },
  },
});
